import React, { PureComponent } from "react";
import {
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Bar,
  Legend,
  Tooltip,
  LabelList,
  ComposedChart,
  Line
} from "recharts";
import styles from "./Charts.local.scss";
import {
  CustomizedXAxisTick,
  CustomizedYAxisTick,
  CustomTooltip
} from "./Common";
import { abbreviateNumber } from "Utils";

const colors = [
  "#FFAC62", // nonBilliable
  "#12D2DE", // billiable
  "#4695DB", // realisedHours
  "#A5C2DE", // remainingHours
  "#02AF8E", // extraTimeSuccess
  "#EDAE49", // extraTimeWarning
  "#D1495B", // extraTimeDanger
  "#205483" // affectedBudget
];

export class CustomizedLabel extends PureComponent {
  render() {
    const { x, y, width, value, color } = this.props;
    const offset = 10;

    return (
      <g>
        <text
          x={x + width / 2}
          y={value >= 0 ? y - offset : y + offset}
          fill={color}
          textAnchor="middle"
          dominantBaseline="middle"
          fontSize={10.5}
        >
          {abbreviateNumber(value)}
        </text>
      </g>
    );
  }
}

export class StandardBarChart extends PureComponent {
  render() {
    const {
      chartData,
      dataKeysY,
      dataKeyX,
      currency,
      legendLabels,
      containerWidth,
      containerHeight,
      showLabels,
      month,
      period,
      day,
      tooltipValueFormat
    } = this.props;
    return (
      <ResponsiveContainer
        width={containerWidth ? containerWidth : "100%"}
        height={containerHeight ? containerHeight : 340}
        className={styles.charts_font}
      >
        <ComposedChart
          data={chartData}
          margin={{ top: 15, right: 40, left: 15, bottom: 0 }}
        >
          <CartesianGrid vertical={false} stroke="#6d7f92" strokeWidth={0.2} />
          <XAxis
            name={dataKeyX}
            dataKey={dataKeyX}
            height={50}
            interval={0}
            padding={{ left: 20, right: 20 }}
            type="category"
            tick={
              <CustomizedXAxisTick
                handleChangeMonthState={this.props.handleChangeMonthState}
                handleChangeDayState={this.props.handleChangeDayState}
                month={month}
                day={day}
                period={period}
              />
            }
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            tick={<CustomizedYAxisTick currency={currency} />}
            axisLine={false}
            tickLine={false}
            type={"number"}
          />
          <Tooltip
            cursor={{ fill: "#f3faff", opacity: 0.6 }}
            content={<CustomTooltip format={tooltipValueFormat} />}
          />
          {showLabels && (
            <Legend
              verticalAlign="top"
              height={containerHeight ? 20 : 70}
              // align={"center"}
              iconType={"square"}
              iconSize={12}
              layout={containerHeight ? "horizontal" : "vertical"}
              wrapperStyle={{
                left: 42,
                top: 0,
                fontWeight: 300,
                fontSize: "14px"
              }}
            />
          )}

          {dataKeysY.map((item, i) => {
            if (item === "affectedBudget") {
              return (
                <Line
                  key={i}
                  name={legendLabels[i]}
                  type="monotone"
                  dataKey={dataKeysY[i]}
                  stroke={"#205483"}
                  fill={"#205483"}
                  dot={{ fill: "#205483", strokeWidth: 4 }}
                  strokeWidth={1.5}
                  animationEasing={"ease-in-out"}
                  animationDuration={800}
                />
              );
            }

            return (
              <Bar
                key={i}
                name={legendLabels[i]}
                type="monotone"
                dataKey={dataKeysY[i]}
                barSize={10}
                radius={[4, 4, 4, 4]}
                fill={colors[i]}
                // label={{ position: "top" }}
                animationEasing={"ease-in-out"}
                animationDuration={800}
                minPointSize={0}
                stackId={
                  item === "nonBillableHours" || item === "billableHours"
                    ? "A"
                    : item === "realizedHours" ||
                      item === "remainingHours" ||
                      item === "extraTimeSuccess" ||
                      item === "extraTimeWarning" ||
                      item === "extraTimeDanger" ||
                      item === "extraTime"
                      ? "B"
                      : "C"
                }
              >
                {showLabels && (
                  <LabelList
                    dataKey={dataKeysY[i]}
                    content={<CustomizedLabel color={colors[i]} />}
                  />
                )}
              </Bar>
            );
          })}
        </ComposedChart>
      </ResponsiveContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/Charts/StandardBarChart.js